import { useEffect, useRef } from "react";

/**
 * Calls `tick` every `intervalMs` while `active`, and once at the start when `leading`.
 * A tick waits for the previous one to finish.
 */
export function usePoll(tick: () => Promise<void>, intervalMs: number, active: boolean, leading: boolean): void {
  const latest = useRef(tick);
  latest.current = tick;

  useEffect(() => {
    if (!active) return;
    let stopped = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const schedule = (delay: number): void => {
      timer = setTimeout(() => {
        void latest.current().finally(() => {
          if (!stopped) schedule(intervalMs);
        });
      }, delay);
    };
    schedule(leading ? 0 : intervalMs);
    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [intervalMs, active, leading]);
}
